<template>
	<span>
		<div class="modal fade" id="modalEjecutivo" role="dialog" aria-labelledby="modalEjecutivoLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="modalEjecutivoLabel">Registrar Ejecutivo</h5>
					</div>
					<div class="modal-body">
						<div class="form-group">
							<label>Descripción: </label>
							<input 
								type="text" 
								class="form-control" 
								placeholder="Ingrese descripción" 
								v-model="form.descripcion" 
								required
								maxlength="250">
							<div v-if="errors && errors.descripcion" class="text-danger">
                                {{ errors.descripcion[0] }}
                            </div>
						</div>
						<div class="form-group">
							<label>Correo: </label>
							<input type="email" class="form-control" placeholder="Ingrese correo" v-model="form.correo" maxlength="125" required>
							<div v-if="errors && errors.correo" class="text-danger">
                                {{ errors.correo[0] }}
                            </div>
						</div>
						<div class="form-group">
							<label>
								Intermediario: 
								<a 
									href="#" 
									v-on:click.prevent="getIntermediarios" 
									class="font-weight-bold"
									v-if="!loadingIntermediarios">
									<small>(actualizar)</small>
								</a>
								<span v-else>
                        			<i class="fas fa-spinner fa-pulse"></i>
                    			</span>
							</label>
							<select2 
								v-model="form.intermediario" 
								name="intermediarioEjecutivo" 
								id="intermediarioEjecutivo"
								:disabled="loadingIntermediarios">
								<option v-for="intermediario in intermediarios" v-bind:value="intermediario.CODIGO_INTERMEDIARIO"> {{ intermediario.DESCRIPCION_INTERMEDIARIO }}
								</option>
							</select2>
							<div v-if="errors && errors.intermediario" class="text-danger">
                                {{ errors.intermediario[0] }}
                            </div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" v-on:click="closeModal" v-bind:disabled="loading">Cancelar</button>
						<button type="button" class="btn btn-primary" v-on:click="store" v-bind:disabled="loading">Crear</button>
					</div>
				</div>
			</div>
		</div>
	</span>
</template>
<script>
	export default{
		data(){
			return{
				form: {
					CODIGO_EJECUTIVO: '',
					DESCRIPCION_EJECUTIVO: '',
					CODIGO_INTERMEDIARIO: '',
					CORREO: '',
				},
				intermediarios: [],
				loadingIntermediarios: false,
				loading: false,
				errors: {},
			}
		},

		mounted(){
			this.getIntermediarios();
		},

		methods: {
			openEjecutivo: function(){
				this.getIntermediarios();
				this.cleanFields();
				$('#modalEjecutivo').modal('show');
			},

			cleanFields: function(){
				this.form.CODIGO_EJECUTIVO = '';
				this.form.DESCRIPCION_EJECUTIVO = '';
				this.form.CODIGO_INTERMEDIARIO = '';
				this.form.CORREO = '';
			},

			closeModal: function(){
				this.cleanFields();
				$('#modalEjecutivo').modal('hide');
			},

			store: function(){
				var url = "/api/ejecutivos/create";
				this.loading = true;
				axios.post(url,{
					'descripcion': this.form.descripcion,
					'correo': this.form.correo,
					'intermediario': this.form.intermediario,
				}).then(response => {
		        	$('#ejecutivo').append($('<option>', {
		        		value: response.data.CODIGO_EJECUTIVO,
		        		text: response.data.DESCRIPCION_EJECUTIVO
		        	}))
		        	.val(response.data.CODIGO_EJECUTIVO)
		        	.trigger('change');
		        	this.closeModal();
		        	this.$toasted.show('El ejecutivo ha sido agregado.');
	        	}).catch(error=>{
	        		console.log(error.response);
	        		this.$toasted.show('Error al agregar Intermediario.');
	        		if (error.response.status === 422) {
                    	this.errors = error.response.data.errors || {};
                    }
	        	}).then(() => {
	        		this.loading = false;
	        	});
			},

			getIntermediarios: function(){
				var url = "/api/intermediarios";
				this.loadingIntermediarios = true;
				axios.get(url).then(response => {
		        	this.intermediarios = response.data;
	        	}).catch(error=>{
	        		console.log(error.response);
	        	}).then(() => {
	        		this.loadingIntermediarios = false;
	        	});
			},
		}
	}
</script>